import { Async } from '@uifabric/utilities';
import * as React from 'react';
import { useConst } from './useConst';
/**
 * Hook to provide an Async instance that is automatically cleaned up on dismount.
 */
export function useAsync() {
    var async = useConst(function () { return new Async(); });
    // Function that returns a function in order to dispose the async instance on unmount
    React.useEffect(function () { return function () { return async.dispose(); }; }, [async]);
    return async;
}
//# sourceMappingURL=useAsync.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/@uifabric/react-hooks/lib/useAsync.js
// module id = 618
// module chunks = 0